import React, { useRef } from "react";
import * as THREE from "three";
import { Sphere, Edges } from "@react-three/drei";
import VRHeadset from "./ModelFiles/VRHeadset";
import { useSmoothPresenceGroup } from "../hooks/useSmoothPresenceGroup";

export default function PlayerFigure({ rotation, position, color, device }) {
  const groupRef = useRef();

  useSmoothPresenceGroup(groupRef, { position, rotation }, 1);

  return (
    <group ref={groupRef}>
      <group position={[0, 0, 0]} rotation={[0, Math.PI / 2, 0]} scale={1.5}>
        <VRHeadset colour={"grey"} clickFunction={() => console.log("hey don't poke me!")} />
        <Sphere
          position={[-0.1, 0.06, 0]}
          scale={0.095}
          receiveShadow
          material-color={color}
          material={new THREE.MeshStandardMaterial()}
        >
          <Edges scale={1} threshold={20} color="grey" />
        </Sphere>
        <Sphere
          position={[-0.1, -0.07, 0]}
          scale={0.05}
          receiveShadow
          material-color={color}
          material={new THREE.MeshStandardMaterial()}
        >
          <Edges scale={1} threshold={20} color="grey" />
        </Sphere>
      </group>
    </group>
  );
}
